'use es6';

import MessageHistory from 'conversations-message-history/web/message-history/components/MessageHistory';
import ThemeConfigProvider from 'conversations-visitor-message-history/theming/providers/ThemeConfigProvider';
import { List, Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import count from 'transmute/count';
import I18n from 'I18n';
import { MessageHistoryConfig } from '../constants/MessageHistoryConfig';
import ConnectedThreadHistoryFetcher from '../containers/ConnectedThreadHistoryFetcher';
import { buildMessageHistoryTheme } from 'conversations-visitor-message-history/utils/buildMessageHistoryTheme';
import ConnectedNewThreadPrompt from '../../thread-view/containers/ConnectedNewThreadPrompt';
import { AriaLiveContextProvider } from 'visitor-ui-component-library/utils/aria-live/AriaLiveContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ThreadHistory extends Component {
  render() {
    const {
      coloring,
      fileAttachments,
      messagesList,
      portalId,
      senders,
      shouldRenderNewThreadPrompt
    } = this.props;

    // The Initial Message Text Box Does not use the same rich text editor as the rest of the messages
    // this is a temporary fix to make sure that the new lines are rendered as <br> tags until we
    // can refactor the initialMessages text box to use the same editor as the rest of the messages
    const messages = messagesList.map(message => {
      if (message.get('@type') === 'INITIAL_MESSAGE') {
        const richText = message.get('richText');
        return richText ? message.set('richText', richText.replace(/\n/g, '<br>')) : message;
      }
      return message;
    });
    return /*#__PURE__*/_jsx(ConnectedThreadHistoryFetcher, {
      messageCount: count(messagesList),
      shouldScrollToBottom: shouldRenderNewThreadPrompt,
      children: /*#__PURE__*/_jsxs(ThemeConfigProvider, {
        themeConfig: buildMessageHistoryTheme({
          coloring
        }),
        children: [/*#__PURE__*/_jsx(AriaLiveContextProvider, {
          children: /*#__PURE__*/_jsx("section", {
            "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.messageHistory'),
            children: /*#__PURE__*/_jsx(MessageHistory, {
              fileAttachments: fileAttachments,
              historyConfig: MessageHistoryConfig,
              messages: messages,
              portalId: portalId,
              senders: senders
            })
          })
        }), shouldRenderNewThreadPrompt && /*#__PURE__*/_jsx(ConnectedNewThreadPrompt, {})]
      })
    });
  }
}
ThreadHistory.propTypes = {
  coloring: PropTypes.object.isRequired,
  fileAttachments: PropTypes.instanceOf(ImmutableMap).isRequired,
  messagesList: PropTypes.instanceOf(List),
  portalId: PropTypes.number.isRequired,
  senders: PropTypes.instanceOf(ImmutableMap).isRequired,
  shouldRenderNewThreadPrompt: PropTypes.bool.isRequired
};
ThreadHistory.displayName = 'ThreadHistory';
export default ThreadHistory;